import Vue from 'vue';

export default {
  orderDetail(email, orderHigherIdExt, userInternalId = null) {
    return Vue.prototype.axios
      .get(`${process.env.VUE_APP_API_ORDER}order-detail`, {
        params: {
          email,
          orderHigherIdExt,
          ...(userInternalId && ({ userInternalId })),
        },
      })
      .then((res) => {
        const response = res.data;
        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
};
